import React from 'react';
import { useTranslation } from 'react-i18next';

import { Statistics } from '~/views/alfred/document-search/document-sources-view/document-sources-table/use-document-sources-table-store/useDocumentSourcesTableStore';
import { useDocumentSearch } from '~/views/alfred/document-search/use-document-search/useDocumentSearch';
import { useSourcesFilterMessages } from '~/views/alfred/document-search/use-sources-filter-messages/useSourcesFilterMessages';

import * as S from './ChatInputContextHeader.styles';

interface ChatInputContextHeaderProps {
  contextCounts?: {
    documentsCount: number;
    subTypeCount: number;
    statistics?: Statistics;
  };
}

export const ChatInputContextHeader = ({
  contextCounts,
}: ChatInputContextHeaderProps) => {
  const { t } = useTranslation('chat');

  const { sourceSelectedBaseMessage } = useSourcesFilterMessages({
    totalDocuments: contextCounts?.documentsCount,
    totalCompanies: contextCounts?.subTypeCount,
    statistics: contextCounts?.statistics,
  });

  const { setIsSearchWithinContext, isSearchWithinContext, isMessagePending } =
    useDocumentSearch(state => ({
      setIsSearchWithinContext: state.setIsSearchWithinContext,
      isSearchWithinContext: state.isSearchWithinContext,
      isMessagePending: state.isMessagePending,
    }));

  return (
    <S.ContextHeaderContainer data-testid="context-header">
      <S.HeaderTextWrapper>
        {isSearchWithinContext ? (
          <>
            <S.HeaderTextDefault data-testid="enabled-context-label">
              {t('contextHeader.searchWithinContext')}
            </S.HeaderTextDefault>
            <S.HeaderTextPrimary>
              {sourceSelectedBaseMessage}
            </S.HeaderTextPrimary>
          </>
        ) : (
          <S.HeaderTextDisabled data-testid="disabled-context-label">
            {t('contextHeader.searchWithinContext')}
          </S.HeaderTextDisabled>
        )}
      </S.HeaderTextWrapper>
      <S.StyledToggle
        isChecked={isSearchWithinContext}
        onToggle={() => setIsSearchWithinContext(!isSearchWithinContext)}
        disabled={isMessagePending}
        aria-label={t('contextHeader.toggleSearchWithinContext')}
      />
    </S.ContextHeaderContainer>
  );
};
